/**
 * Samouczek 'Sprzedaż — jak zrobić paragon'. Ksztalt danych: patrz KONTRAKT.md
 *
 * Opis oparty na kodzie POS (PosPage.jsx, PaymentSection.jsx, CashPaymentModal.jsx,
 * SplitPaymentModal.jsx, DiscountModal.jsx, useBarcodeScanner.js, useFiscalPrinter.js,
 * TransactionsList.jsx) i na sprzedazy testowej PAR/0014/09/2026/KAL na test.v3system.pl.
 */
const OBRAZ = (plik, opis) => ({ plik, opis });

const DZIALY = {
  A: { tytul: 'Koszyk', opis: 'Skaner albo wyszukiwarka, potem ilość. Tu decydujesz, co jest na paragonie.' },
  B: { tytul: 'Płatność', opis: 'Od przycisku „Dalej" do „Zapłać": rabat, wybór formy płatności, wyliczenie reszty.' },
  C: { tytul: 'Po sprzedaży', opis: 'Co system mówi po „Zapłać", co robi drukarka i gdzie potem znaleźć paragon.' },
};

const PARAGON = {
  id: 'paragon',
  dzialy: DZIALY,
  tytul: 'Sprzedaż — jak zrobić paragon',
  dlaKogo: 'Kasjerzy',
  czas: '4 minuty',
  pdf: '/instrukcje/paragon.pdf',
  wstep: 'Zwykła sprzedaż: klient kładzie towar na ladzie, Ty skanujesz, wybierasz, czym płaci, '
    + 'i klikasz „Zapłać". System zapisuje paragon i wysyła go na drukarkę fiskalną. '
    + 'Zanim zaczniesz, upewnij się, że u góry po prawej jest „Zamknij zmianę" — to znaczy, '
    + 'że Twoja zmiana jest otwarta. Bez otwartej zmiany przycisk „Zapłać" jest wyszarzony.',
  kroki: [
    {
      n: 1,
      dzial: 'A',
      tytul: 'Zeskanuj kod z opakowania',
      tresc: 'Najszybciej: strzel czytnikiem w kod kreskowy. Nie musisz nigdzie klikać ani ustawiać '
        + 'kursora — skaner sam wpisuje kod i zatwierdza go, a produkt pojawia się w koszyku. '
        + 'Kolejny skan tego samego produktu dokłada sztukę. Warunek: u góry musi być zaznaczony '
        + 'kwadracik „Skanuj". Jeśli po skanie wyskoczy „Nie znaleziono produktu o kodzie…", '
        + 'produktu nie ma w systemie — znajdź go po nazwie (krok 2) albo zgłoś kierownikowi.',
      obraz: OBRAZ('/instrukcje/paragon-1-skaner.jpg', 'Produkt w koszyku po zeskanowaniu kodu'),
    },
    {
      n: 2,
      dzial: 'A',
      tytul: 'Albo wpisz nazwę w pole pod koszykiem',
      tresc: 'Pole „Nazwa produktu lub kod kreskowy…" jest pod listą pozycji. Wpisz kawałek nazwy '
        + '(co najmniej dwie litery) — pod spodem wysunie się lista z nazwą, kodem, stanem i ceną. '
        + 'Kliknij właściwy wiersz albo jego „+". Enter bierze pierwszy wynik z listy. '
        + 'Zaznaczone „Dostępne" ukrywa produkty, których nie ma na stanie.',
      obraz: OBRAZ('/instrukcje/paragon-2-wyszukiwarka.jpg', 'Wyszukiwarka z listą podpowiedzi'),
    },
    {
      n: 3,
      dzial: 'A',
      tytul: 'Popraw ilość albo usuń pozycję',
      tresc: 'W kolumnie ILOŚĆ „+" dokłada sztukę, „−" odejmuje. Krzyżyk w kolumnie AKCJE usuwa całą '
        + 'pozycję. Kwota do zapłaty w zielonej ramce przelicza się od razu. Chcesz zacząć od nowa — '
        + '„Wyczyść" nad koszykiem kasuje wszystko. „Szkic" odkłada koszyk na później '
        + '(np. klient poszedł po portfel), znajdziesz go w zakładce „Szkice".',
      obraz: OBRAZ('/instrukcje/paragon-3-ilosc.jpg', 'Przyciski plus, minus i krzyżyk przy pozycji'),
    },
    {
      n: 4,
      dzial: 'B',
      tytul: 'Kliknij „Dalej"',
      tresc: 'Gdy koszyk jest gotowy, kliknij zielony przycisk „Dalej" na dole. Dopóki tego nie zrobisz, '
        + 'przyciski płatności są schowane. Sprawdź jeszcze kwotę „Do zapłaty" pod przyciskiem.',
      obraz: OBRAZ('/instrukcje/paragon-4-dalej.jpg', 'Przycisk Dalej pod koszykiem'),
    },
    {
      n: 5,
      dzial: 'B',
      tytul: 'Zapytaj klienta o aplikację',
      tresc: 'Wyskakuje okno „APLIKACJA SFD STACJONARNIE". Zadaj klientowi pytanie z okna i kliknij '
        + '„OK - Zapytalem". To jedyna droga dalej — okno nie ma krzyżyka.',
      obraz: OBRAZ('/instrukcje/paragon-5-aplikacja.jpg', 'Okno z pytaniem o aplikację SFD'),
    },
    {
      n: 6,
      dzial: 'B',
      tytul: 'Jeśli trzeba — nadaj rabat',
      tresc: 'Przycisk „Rabaty" (na dole, po lewej od „Zapłać") otwiera okno „Dostepne rabaty" '
        + 'z rabatami Twojego sklepu. „+ Dodaj" nakłada rabat na cały koszyk, a po zamknięciu okna '
        + 'w kolumnie RABAT widzisz przekreśloną starą cenę. Pomyłkę cofniesz w tym samym oknie: '
        + '„Usun ten rabat". Niektóre rabaty mają warunki — np. 50 zł tylko od 200 zł w koszyku — '
        + 'i miesięczne limity; gdy limit się wyczerpie, wiersz jest czerwony i nic nie da się dodać. '
        + 'Przycisku „Rabaty" nie masz? Twoje konto nie ma uprawnienia do rabatów.',
      obraz: OBRAZ('/instrukcje/paragon-6-rabaty.jpg', 'Okno z listą dostępnych rabatów'),
    },
    {
      n: 7,
      dzial: 'B',
      tytul: 'Wybierz, czym płaci klient',
      tresc: 'Pięć kafelków: „Gotówka", „Karta", „BLIK", „Kupon", „Dzielona". Wybrany ma pełne, '
        + 'kolorowe tło. Domyślnie zaznaczona jest gotówka. Przy karcie i BLIK-u po kliknięciu '
        + '„Zapłać" paragon zapisuje się od razu — bez dodatkowego okna, więc najpierw przyjmij '
        + 'płatność na terminalu, potem klikaj. Gotówka i płatność dzielona otwierają okno '
        + '(kroki 8 i 9). Kwota na „Zapłać" to kwota po rabacie.',
      obraz: OBRAZ('/instrukcje/paragon-7-metody.jpg', 'Kafelki metod płatności i przycisk Zapłać'),
    },
    {
      n: 8,
      dzial: 'B',
      tytul: 'Klient płaci dwoma sposobami? Kliknij „Dzielona"',
      tresc: 'Sam kafelek „Dzielona" od razu otwiera okno „Platnosc dzielona" z wierszami Gotowka, '
        + 'Karta, BLIK, Kupon. Wpisz kwotę w pierwszy wiersz (np. ile klient daje gotówką), '
        + 'a przy drugim kliknij „Reszta" — system dopisze brakującą kwotę. „Zaplac" w tym oknie '
        + 'odblokuje się dopiero, gdy „Suma" u góry zrówna się z „Do zaplaty" (wtedy jest zielona). '
        + 'To „Zaplac" od razu zapisuje paragon — gotówkowej reszty tu nie wylicza.',
      obraz: OBRAZ('/instrukcje/paragon-8-dzielona.jpg', 'Okno płatności dzielonej'),
    },
    {
      n: 9,
      dzial: 'B',
      tytul: 'Gotówka: wpisz, ile dał klient, i kliknij „Zapłać"',
      tresc: 'Przy gotówce „Zapłać" otwiera okno „Platnosc gotowkowa". W pole „Kwota otrzymana" '
        + 'wpisz, ile pieniędzy dał klient, albo kliknij gotową kwotę z rzędu „Szybkie kwoty". '
        + 'W niebieskiej ramce „Reszta do wydania" widzisz, ile wydać. Za mała kwota podświetla pole '
        + 'na czerwono i blokuje przycisk. Zielone „Zaplac" w oknie zapisuje paragon i wysyła go '
        + 'na drukarkę. Nic nie klikaj drugi raz — przycisk pokazuje „Przetwarzanie…", aż skończy.',
      obraz: OBRAZ('/instrukcje/paragon-9-gotowka.jpg', 'Okno płatności gotówkowej z wyliczoną resztą'),
    },
    {
      n: 10,
      dzial: 'C',
      tytul: 'Przeczytaj komunikaty i sprawdź boks „Paragony"',
      tresc: 'Po „Zapłać" koszyk się czyści, a u góry po prawej pojawiają się dymki. Zielony '
        + '„Paragon zostal pomyslnie zarejestrowany!" znaczy, że sprzedaż jest w systemie. '
        + 'Drugi dymek jest od drukarki: „Paragon fiskalny wydrukowany #…" — wszystko dobrze; '
        + 'czerwony „Drukarka fiskalna nie jest polaczona! Paragon NIE zostal wydrukowany…" — '
        + 'sprzedaż jest zapisana, ale klient nie ma paragonu, patrz krok 12. Sprzedaż od razu '
        + 'ląduje na górze boksu „Paragony": zielony „✓" = wydrukowany, żółty „?" = niewydrukowany, '
        + 'czerwony „✗" = drukarka zgłosiła błąd.',
      obraz: OBRAZ('/instrukcje/paragon-10-po-sprzedazy.jpg', 'Boks Paragony z najnowszymi sprzedażami'),
    },
    {
      n: 11,
      dzial: 'C',
      tytul: 'Znajdź paragon w zakładce „Paragony"',
      tresc: 'U góry kliknij „Paragony". Lista pokazuje dzisiejsze sprzedaże od najnowszej: numer '
        + '(PAR/…/KAL), godzinę, kasjera, kwotę, rabat, płatność. Kolumna „Fisk" to stan wydruku: '
        + '„F" — wydrukowany, „NF" — niewydrukowany, „F!" — błąd drukarki. Starsze dni znajdziesz '
        + 'przyciskami „Wczoraj", „Miesiąc" albo datami „Od"–„Do".',
      obraz: OBRAZ('/instrukcje/paragon-11-lista.jpg', 'Lista paragonów z kolumną Fisk'),
    },
    {
      n: 12,
      dzial: 'C',
      tytul: 'Nie wydrukował się? Menu „…" przy paragonie',
      tresc: 'Trzy kropki na końcu wiersza otwierają menu: „Szczegóły", „Drukuj paragon", '
        + '„Fiskalizuj", „Zwrot", „Płatność". Gdy paragon ma „NF", podłącz drukarkę przyciskiem '
        + 'w górnym pasku (czerwone „Rozłączona" ma zmienić się w zielone „Drukarka OK") '
        + 'i kliknij „Fiskalizuj" — dopóki drukarka jest rozłączona, opcja jest szara. '
        + 'Przy „F!" opcja nazywa się „Ponów fiskalizację". Przy „F" — „Ponów druk fiskalny", '
        + 'a system ostrzega, że zrobi duplikat na drukarce; nie klikaj tego bez powodu.',
      obraz: OBRAZ('/instrukcje/paragon-12-menu.jpg', 'Menu przy paragonie z opcją Fiskalizuj'),
    },
  ],
  uwagi: [
    'Karta i BLIK nie mają okna potwierdzenia — „Zapłać" od razu zapisuje paragon. Najpierw terminal, potem klik.',
    'Czerwony dymek o drukarce nie cofa sprzedaży. Paragon jest w systemie, tylko nie wyszedł z drukarki — dokończ wydruk z zakładki „Paragony" („Fiskalizuj"), a nie sprzedawaj drugi raz.',
    'Sprawdzaj kolumnę „Fisk" przed końcem zmiany. „NF" i „F!" to paragony, których klient nie dostał.',
    'Rabat liczy się od całego koszyka, a kwota na „Zapłać" jest już po rabacie. Sprawdź ją, zanim klikniesz.',
    'Płatność dzielona nie liczy reszty z gotówki — wpisz w wiersz „Gotowka" dokładnie tyle, ile zostaje w kasie.',
    'Paragon z NIP nabywcy i płatność kuponem (kafelek „Kupon") mają osobne samouczki.',
  ],
};

export default PARAGON;
